import { SessionModel } from '@/models/auth/session';
import { SessionRGOModel } from '@/models/auth/session-rgo';
import { DEFAULT_IMAGES_PATH, PARTNERS_DATA_TYPE_FIELDS } from '@/utils/constants';
import { checkCDNUrl, isEmptyValue, sortByProperty } from '@/utils/utils';

/**
 *
 * This Auth serializer is responsible for converting the Raw format to model.
 *
 */
export class AuthSerializer {
  private static INSTANCE = new AuthSerializer();

  static get instance() {
    return this.INSTANCE;
  }

  public sessionModelSerializer(res: any, accessToken?: string) {
    const result: SessionModel = {
      access_token: res.access_token || accessToken,
      access_token_validity: res.access_token_validity,
      cdn_urls: res.cdn_urls,
      provided_at: res.provided_at,
      user_id: res.user_id,
      username: res.username,
      permissions: !isEmptyValue(res.permissions) && res.permissions.length > 0 ? res.permissions : [],
      email: res.email,
      isSuperAdmin: res.permissions ? res.permissions.indexOf('GROUP_SUPER_ADMIN') !== -1 : false,
      first_name: res.first_name,
      last_name: res.last_name,
      user_category: res.user_category,
      thumbnail: res.thumbnail,
      tenant: res.tenant,
      isImpersonateUser: res.isImpersonateUser || false,
      thumbnail_url: this.getThumbnailUrl(res),
      user_display_name: this.getUserDisplayName(res),
      group_school_id: res.group_school_id,
      isTenantConfigured: res.isTenantConfigured,
      isHideRoleMenu: res.isHideRoleMenu,
    };
    return result;
  }

  public async modifiedPartnerListSerializer(list: any) {
    let educatorsArray: any = [];
    list.educators = [];
    if (list[PARTNERS_DATA_TYPE_FIELDS.labSchools]
      && list[PARTNERS_DATA_TYPE_FIELDS.labSchools].length > 0) {
        educatorsArray = [...educatorsArray, ...list[PARTNERS_DATA_TYPE_FIELDS.labSchools]];
    }

    if (list[PARTNERS_DATA_TYPE_FIELDS.schools]
      && list[PARTNERS_DATA_TYPE_FIELDS.schools].length > 0) {
        educatorsArray = [...educatorsArray, ...list[PARTNERS_DATA_TYPE_FIELDS.schools]];
    }
    list.educators = educatorsArray;
    const partnerTypes = Object.keys(list) || [];
    for await (const partnerType of partnerTypes) {
      if (list[partnerType] && Array.isArray(list[partnerType])) {
        for (const iterator of list[partnerType]) {
          iterator.logo = iterator.logo ? checkCDNUrl(iterator.logo) : '';
          const metrics = iterator.metrics ? iterator.metrics : null;
          iterator.metrics = {
            data_count: metrics && metrics.data_count ? metrics.data_count : null,
            total_students: metrics && metrics.total_students ? metrics.total_students : 0,
            total_teachers: metrics && metrics.total_teachers ? metrics.total_teachers : 0,
          };
        }
        sortByProperty(list[partnerType], 'seq_id', 'DESC');
      }
    }
    return list;
  }


  public modifiedConentProviderPartnerListSerializer(list: any) {
    let contentPrividerPartner: any = [];
    if (list[PARTNERS_DATA_TYPE_FIELDS.contentDevelopers]
      && list[PARTNERS_DATA_TYPE_FIELDS.contentDevelopers].length > 0) {
        contentPrividerPartner = [...contentPrividerPartner, ...list[PARTNERS_DATA_TYPE_FIELDS.contentDevelopers]];
    }

    if (list[PARTNERS_DATA_TYPE_FIELDS.integrationPartners]
      && list[PARTNERS_DATA_TYPE_FIELDS.integrationPartners].length > 0) {
        contentPrividerPartner = [...contentPrividerPartner, ...list[PARTNERS_DATA_TYPE_FIELDS.integrationPartners]];
    }
    return contentPrividerPartner;
  }

  public sessionModelRGOSerializer(res: any) {
    const result: SessionRGOModel = {
      authenticated: {
        authenticator: 'authenticator:auth-api-3',
        accessToken: res.access_token,
        user: {
          username: res.username,
          id: res.user_id,
          avatarUrl: this.getThumbnailUrl(res),
          isImpersonateUser: res.isImpersonateUser || false,
        },
        cdnUrls: {
          user: res.cdn_urls.user_cdn_url,
          content: res.cdn_urls.content_cdn_url,
        },
        isAuthenticated: true,
      },
    };
    return result;
  }

  private getThumbnailUrl(res: any) {
    let thumbnailUrl: string = '';
    if (res.thumbnail) {
      thumbnailUrl = (res.cdn_urls.user_cdn_url + res.thumbnail);
    } else {
      thumbnailUrl = DEFAULT_IMAGES_PATH.profile;
    }
    return thumbnailUrl;
  }

  private getUserDisplayName(res: any) {
    let userDisplayName: string = '';
    if (res.first_name) {
      userDisplayName = res.first_name;
      if (res.last_name) {
        userDisplayName += ` ${res.last_name}`;
      }
    } else if (res.username) {
      userDisplayName = res.username;
    } else if (res.email) {
      userDisplayName = res.email.split('@')[0];
    }
    return userDisplayName;
  }

}

export const authSerializer = AuthSerializer.instance;
